import './CapitalAccountsBanner.scss';
import {type CapitalAccountsStoreState,
  type DocumentsStoreState } from '../../../store/slices';
import classNames from 'classnames';
import { Button } from 'components/InteractiveUIControls/Button/Button';
import { Svgicon } from 'components/Svgicon/Svgicon';
import {useRef} from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {isTablet } from 'services/mobile';
import { COLORS } from 'types/Colors';

type CapitalAccountsBannerProps = {
  isTheOnlyOneBanner: boolean,
};

export const CapitalAccountsBanner = ({ isTheOnlyOneBanner }: CapitalAccountsBannerProps) => {
  const navigate = useNavigate();
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    otherCategories,
  } = useSelector<{ documents: DocumentsStoreState, }>(
    (state) => state.documents,
  ) as DocumentsStoreState;
  const {
    hasCapitalAccounts,
  } = useSelector<{ capitalAccounts: CapitalAccountsStoreState, }>(
    (state) => state.capitalAccounts,
  ) as CapitalAccountsStoreState;

  const onViewButtonClick = () => navigate('/firm/capital-accounts');

  if (!otherCategories?.length && !hasCapitalAccounts) {
    return <>{isTablet() ? null : <div
      className='flex max-h-full w-full justify-between rounded-medium bg-black-200 p-[1rem] ms:min-h-[9.4375rem] ms:p-[0.875rem]'
      data-test='empty-card-capital-accounts'
      ref={containerRef}
    />}</>;
  }

  return (
    <div
      className={classNames('capital-accounts-container flex max-h-[7rem] w-full justify-between overflow-hidden rounded-medium bg-main-800 p-[1rem] hover:cursor-pointer ms:max-h-[9.4375rem] ms:gap-0.75 ms:p-0.875', {'ms:!max-h-full ms:!h-full': isTheOnlyOneBanner})}
      data-test='view-capital-accounts-button'
      onClick={onViewButtonClick}
      ref={containerRef}
    >
      <div className='flex size-full flex-col justify-between gap-[0.5rem] ms:w-auto ms:gap-[1.9375rem]'>
        <div>
          <h3 className='m-0 truncate text-title-4 font-semibold text-white-999'>
            Capital {!isTablet() && <br />}
            accounts
          </h3>
        </div>
        <div className='flex size-full justify-between'>
          <Button
            className='self-center overflow-hidden ms:!size-9 ms:self-end'
            data-test='view-capital-accounts-button'
            icon='only'
            iconClassName='icon-container size-[1.25rem]'
            iconColor={COLORS['$main-800']}
            iconid='arrow-right-2f'
            size='medium'
            squared
            tooltipWrapperClass='!justify-start'
            type='white'
          />
          {isTablet() ? <div><Svgicon className='size-[12.5rem]' id='CA-banner' /></div> : null}
        </div>
      </div>
      {isTablet() ? null : <Svgicon className='size-[12.5rem]' id='CA-banner' />}
    </div>
  );
};
